import { render, staticRenderFns } from "./fccApresentacao.vue?vue&type=template&id=0e4c0c15"
import script from "./fccApresentacao.vue?vue&type=script&lang=js"
export * from "./fccApresentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports